import { Get, Post } from "services";
import { ApiPath } from "paths";

export const verifyEmail = async ({ email }) => {
  const res = await Get(`${ApiPath.CHECK_STAFF}`, { email });
  return res.data;
};

export const signIn = async ({ email, password }) => {
  const body = {
    clientId: "VENUE_DASHBOARD",
    grantType: "email",
    email,
    password,
  };
  const res = await Post(`${ApiPath.SIGN_IN}`, body);
  return res.data;
};

export const checkProfileEmail = async ({ email }) => {
  const res = await Get(`${ApiPath.PROFILE_CHECK}`, { email });
  return res.data;
};

export const requestForgotPassword = async ({ email }) => {
  const res = await Get(`${ApiPath.PROFILE_FORGOT_PASSWORD}`, { email });
  return res.data;
};

export const resetPassword = async ({ token, password }) => {
  const res = await Post(`${ApiPath.PROFILE_RESET_PASSWORD}`, { token, password });
  return res.data;
};
